export default {
  getAddressPosition(state) {
    return state.create.address?.position;
  },
  getMapDestination(_, getters) {
    const position = getters.getAddressPosition;
    return position ? [{ position: { ...position } }] : [];
  }
};
